export const FIELD_METADATA_KEY = 'fields';
